// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.3.0_webpack@5.99.8/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AutoCompleteResultRow-cls1___040bd22bafdb1b22322{/*!*/}.AutoCompleteResultRow-cls2__d057ec5da7ede1083aa4{font-weight:700;line-height:1.1;color:#000;text-overflow:ellipsis;overflow:hidden;white-space:nowrap}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"cls1": "AutoCompleteResultRow-cls1___040bd22bafdb1b22322",
	"cls2": "AutoCompleteResultRow-cls2__d057ec5da7ede1083aa4 AutoCompleteResultRow-cls1___040bd22bafdb1b22322"
};
export default ___CSS_LOADER_EXPORT___;
